class StatusChecker {
    constructor() {
        document.querySelectorAll('.js-status-checker-trigger').forEach(el => el.addEventListener('click', this.onTriggerClick.bind(this)));
    }

    onTriggerClick(e) {
        e.preventDefault();

        $.fancybox(document.querySelector('#statusCheckerTemplate').innerHTML.trim(), {
            padding: 0,
            fitToView: false,
            margin: 10,
            afterLoad() {},
            afterShow: () => {
                this.bindForm();
                //this.legacyInitAfterLoad();
            }
        });
    }

    bindForm() {
        document.querySelector('.status-checker-popup .status-checker-form__submit').addEventListener('click', this.onSubmit.bind(this));
    }

    async onSubmit(e) {
        const button = document.querySelector('.status-checker-popup .status-checker-form__submit');
        button.disabled = true;

        //document.querySelector('.status-checker-popup .status-checker-result').classList.remove('hidden');
        //fetch('/bitrix/services/main/ajax.php');
        let response;

        try {
            response = await BX.ajax.runComponentAction('nav:sale.status_checker', 'get', {
                mode: 'class',
                data: {
                    lang: appData.language,
                    accountNumber: document.querySelector('.status-checker-form__input').value
                },
            });
        } catch (ex) {
            console.log(ex.errors);

            alert('Ошибка. ' + ex.errors.map(item => item.message).join('\n'));
            return;
        } finally {
            button.disabled = false;
        }

        let resultNode = document.querySelector('.status-checker-popup .status-checker-result');
        resultNode.innerHTML = response.data.result;
        document.querySelector('.status-checker-popup .status-checker-form').classList.add('hidden');
        resultNode.classList.remove('hidden');
    }

    async showStatus(orderId) {
        let response;

        try {
            response = await BX.ajax.runComponentAction('nav:sale.status_checker', 'get', {
                mode: 'class',
                data: {
                    lang: appData.language,
                    accountNumber: orderId
                },
            });
        } catch (ex) {
            console.log(ex.errors);

            alert('Ошибка. ' + ex.errors.map(item => item.message).join('\n'));
            return;
        }

        let el = document.querySelector('#statusCheckerTemplate').content.cloneNode(true);
        el.querySelector('.status-checker-form').classList.add('hidden');
        el.querySelector('.status-checker-result').innerHTML = response.data.result;
        el.querySelector('.status-checker-result').classList.remove('hidden');

        $.fancybox(Array.prototype.reduce.call(el.childNodes, (result, node) => result + (node.outerHTML || node.nodeValue), '').trim(), {
            padding: 0,
            fitToView: false,
            margin: 10,
        });
    }
}

export default new StatusChecker();